<template>
    <div class="ques-edit" :class="[isOpenOldEdit ? 'ques-edit-old' : '']">
        <div class="header">
            <div class="go-back" @click="goBack">返回</div>
            <div class="line">|</div>
            <div>添加回答</div>
        </div>
        <!-- 添加成功 -->
        <div v-if="showSubmitSucc" class="submit-succ">
            <div class="icon"></div>
            <div class="content">恭喜成功上传问答</div>
            <div class="btns">
                <veui-button class="detail" @click="toQuesList">查看详情</veui-button>
                <veui-button @click="uploadMore">再传一个</veui-button>
            </div>
        </div>
        <template v-else-if="isOpenOldEdit">
            <ques-old-edit
                :qa-info="qaInfo"
                @hideQuesEdit="goBack"
                @submitSuccess="() => {
                    showSubmitSucc = true;$emit('submitSuccess')
                }"
            ></ques-old-edit>
        </template>
        <template v-else>
            <section class="ques-detail">
                <div class="title">问答详情</div>
                <veui-alert
                    v-if="showTips && isAiQuestion"
                    class="alert"
                    status="success"
                    ui="strong"
                >
                    AI为您生成如下内容，仅供参考，不能代替专业法律意见，请您酌情使用，确保不侵犯他人合法权益。
                    <template #extra>
                        <div class="close" @click="closeTips('showTips')"></div>
                    </template>
                </veui-alert>
                <div class="answer-content">
                    <div class="ques-editor-box">
                        <div class="form-item wt">
                            <div class="form-item-label required">回答标题</div>
                            <div class="question">
                                <div
                                    class="question-item"
                                >
                                    <div
                                        class="my-input"
                                    >
                                        <veui-input
                                            v-model="question"
                                            placeholder="请输入问答标题"
                                            :maxlength="100"
                                            :strict="true"
                                            class="question-input"
                                            :disabled="qaInfo.banEditTitle"
                                            :class="[isQuestionFocus ? 'focus' : '', isShowTips ? 'error' : '']"
                                            @focus="handleIntroFocus('isQuestionFocus', true)"
                                            @blur="handleIntroFocus('isQuestionFocus', false)"
                                        />
                                        <div class="text-num">
                                            <span class="cur-num">{{ question && question.length || 0 }}</span>/100
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-item intro">
                            <div class="form-item-label required">核心结论</div>
                            <div
                                class="my-textarea"
                                :class="[isConclusionFocus ? 'focus' : '']"
                            >
                                <veui-textarea
                                    v-model="conclusion"
                                    placeholder="请输入核心结论"
                                    :maxlength="5000"
                                    :strict="true"
                                    @focus="handleIntroFocus('isConclusionFocus', true)"
                                    @blur="handleIntroFocus('isConclusionFocus', false)"
                                />
                                <div class="text-num">
                                    <span class="cur-num">{{ conclusion && conclusion.length || 0 }}</span>/5000
                                </div>
                            </div>
                        </div>
                        <div class="form-item intro">
                            <div class="form-item-label required">法律依据</div>
                            <div
                                class="my-textarea"
                                :class="[isBasisFocus ? 'focus' : '']"
                            >
                                <veui-textarea
                                    v-model="basis"
                                    placeholder="请输入法律依据"
                                    :maxlength="5000"
                                    :strict="true"
                                    @focus="handleIntroFocus('isBasisFocus', true)"
                                    @blur="handleIntroFocus('isBasisFocus', false)"
                                />
                                <div class="text-num">
                                    <span class="cur-num">{{ basis && basis.length || 0 }}</span>/5000
                                </div>
                            </div>
                        </div>
                        <div class="form-item intro">
                            <div class="form-item-label required">法律分析</div>
                            <div
                                class="my-textarea"
                                :class="[isAnalyseFocus ? 'focus' : '']"
                            >
                                <veui-textarea
                                    v-model="analyse"
                                    placeholder="请输入法律分析"
                                    :maxlength="5000"
                                    :strict="true"
                                    @focus="handleIntroFocus('isAnalyseFocus', true)"
                                    @blur="handleIntroFocus('isAnalyseFocus', false)"
                                />
                                <div class="text-num">
                                    <span class="cur-num">{{ analyse && analyse.length || 0 }}</span>/5000
                                </div>
                            </div>
                        </div>
                        <div class="form-item intro">
                            <div class="form-item-label required">律师观点</div>
                            <div
                                class="my-textarea"
                                :class="[isOpinionFocus ? 'focus' : '']"
                            >
                                <veui-textarea
                                    v-model="opinion"
                                    placeholder="请输入律师观点"
                                    :maxlength="5000"
                                    :strict="true"
                                    @focus="handleIntroFocus('isOpinionFocus', true)"
                                    @blur="handleIntroFocus('isOpinionFocus', false)"
                                />
                                <div class="text-num">
                                    <span class="cur-num">{{ opinion && opinion.length || 0 }}</span>/5000
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="answer-exp">
                        <div class="exp-title">回答范例({{ curPage + 1 }}/{{ quesList.length }})</div>
                        <div class="question">{{ quesList[curPage] && quesList[curPage].question || '' }}</div>
                        <!--bca-disable-->
                        <div class="answer" v-html="quesList[curPage] && quesList[curPage].answer || ''"></div>
                        <div class="btns">
                            <veui-button
                                ui="text"
                                :disabled="curPage === 0"
                                @click="changeQues('last')"
                            ><img class="btns-img" src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/prev.png">上一个</veui-button>
                            <veui-button
                                ui="text"
                                :disabled="curPage === quesList.length - 1"
                                @click="changeQues('next')"
                            >下一个<img class="btns-img" src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/next.png"></veui-button>
                        </div>
                    </div>
                </div>
            </section>
            <section class="ques-submit">
                <veui-button class="btn" @click="handleSubmit">上传</veui-button>
                <veui-button class="btn cancel" @click="goBack">取消</veui-button>
            </section>
        </template>
    </div>
</template>

<script>
// 案例新增页
import {Input, Button, Alert, Textarea} from 'veui';
import {quesExps} from '../data';
import quesOldEdit from './quesOldEdit.vue';
export default {
    name: '',
    components: {
        'ques-old-edit': quesOldEdit,
        'veui-button': Button,
        'veui-input': Input,
        'veui-alert': Alert,
        'veui-textarea': Textarea
    },
    data() {
        return {
            quesList: quesExps,
            // 提交锁
            isSubmit: false,
            showSubmitSucc: false,
            curPage: 0,
            isAiQuestion: false,
            showTips: true,
            isShowTips: false,
            question: '',
            opinion: '', // 律师观点
            basis: '', // 法律依据
            conclusion: '', // 核心结论
            analyse: '',
            isQuestionFocus: false,
            isOpinionFocus: false,
            isBasisFocus: false,
            isConclusionFocus: false,
            isAnalyseFocus: false,
            isAdd: false, // 是否点击新建一个
            fr: this.$route.query.fr || ''
        };
    },
    props: {
        qaInfo: {
            type: Object,
            default: () => ({})
        },
        isOpenOldEdit: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        qaInfo: {
            deep: true,
            immediate: true,
            handler(val) {
                if (!val.is_struct && val.reply_content) {
                    this.isAiQuestion = val.showTips || false;
                    this.question = val.title || '';
                    this.conclusion = this.fiterLabelHandle(val.reply_content);
                    return;
                }
                if (Object.keys(val).length > 0) {
                    this.isAiQuestion = val.showTips || false;
                    this.question = val.title || '';
                    this.opinion = val.opinion || '';
                    this.basis = val.law || '';
                    this.conclusion = val.abstract || '';
                    this.analyse = val.law_analysis || '';
                }
            }
        }
    },
    mounted() {
        this.$wywLog.send({
            serverId: 19022,
            area: 'question-edit',
            action: 'show'
        });
        if (localStorage.getItem('ques-edit-tips') === '1') {
            this.showTips = false;
        };
    },
    methods: {
        closeTips(type = 'showTips') {
            localStorage.setItem('ques-edit-tips', '1');
            this.showTips = false;
        },
        handleIntroFocus(type, isFocus) {
            this[type] = isFocus;
        },
        isWhitespace(str) {
            return /^\s*$/.test(str);
        },
        // 提交
        handleSubmit() {
            const {
                question = '',
                opinion = '',
                basis = '',
                conclusion = '',
                analyse = ''
            } = this || {};
            if (!question || !opinion || !basis || !conclusion || !analyse || this.isWhitespace(question)
                || this.isWhitespace(opinion) || this.isWhitespace(basis)
                || this.isWhitespace(conclusion) || this.isWhitespace(analyse)) {
                let toast = {
                    content: '请正确填写问题以及回答内容后再提交',
                    duration: 3
                };
                this.$wywLog.send({
                    serverId: 19022,
                    area: 'question-edit-upload',
                    action: 'click',
                    index: 0
                });
                this.$Message.error(toast);
                return;
            }
            this.$wywLog.send({
                serverId: 19022,
                area: 'question-edit-upload',
                action: 'click',
                index: 1
            });
            this.submitQueston();
        },
        goBack() {
            this.$wywLog.send({
                serverId: 19022,
                area: 'question-edit-cancle',
                action: 'click'
            });
            if (this.fr === 'hotQuestion') {
                this.$router.push({
                    name: 'hotQuestion'
                });
                return;
            }
            this.clearForm();
            this.$emit('hideQuesEdit');
        },

        /**
         * 点击再传一个
         */

        uploadMore() {
            this.clearForm();
            if (this.qaInfo.banEditTitle || this.qaInfo.isFormList) {
                if (this.fr === 'hotQuestion') {
                    this.$router.push({
                        name: 'hotQuestion'
                    });
                    return;
                }
                this.$emit('hideQuesEdit');
                return;
            }
            this.showSubmitSucc = false;
            this.isAdd = true;
        },

        /**
         * 跳转列表页
         */

        toQuesList() {
            this.$emit('toQuesList');
        },
        changeQues(type) {
            this.$wywLog.send({
                serverId: 19022,
                area: 'question-edit-' + type,
                action: 'click'
            });
            if (type === 'last' && this.curPage > 0) {
                this.curPage = this.curPage - 1;
            }
            if (type === 'next' && this.curPage < this.quesList.length - 1) {
                this.curPage = this.curPage + 1;
            }
            if (document.getElementsByClassName('answer')[0]) {
                document.getElementsByClassName('answer')[0].scrollTop = 0;
            }
        },
        /**
         * 设置editor内容
         * @param {string} content 内容
         */

        setContent(content) {
            this.$nextTick(() => {
                this.$refs.editorItem && this.$refs.editorItem.setContent(content);
            });
        },

        /**
         * 提交回答
         * @param {String} content 输入的回答
         */

        submitQueston() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            const {packId, id, qid} = this.qaInfo;
            const {
                question = '',
                opinion = '',
                basis = '',
                conclusion = '',
                analyse = ''
            } = this || {};
            const data = {
                content: `<p><strong>核心结论</strong><p>${conclusion}</p><br>`
                    + `<strong>法律依据</strong><p>${basis}</p><br>`
                    + `<strong>法律分析</strong><p>${analyse}</p><br>`
                    + `<strong>律师观点</strong><p>${opinion}</p><br></p>`,
                ...(((packId || qid) && !this.isAdd) && {
                    pack_id: packId || qid
                }),
                type: 'submit',
                ...(id && !this.isAdd && {
                    content_id: id,
                    type: 'edit'
                }),
                origin: 'knowledge',
                title: question,
                opinion,
                law_analysis: analyse,
                law: basis,
                abstract: conclusion,
                is_struct: 1
            };
            this.$http({
                method: 'post',
                url: '/bp/api/content/save',
                data
            }).then(res => {
                this.isSubmit = false;
                if (res && +res.code === 0) {
                    this.$toast.success(
                        '内容已成功提交，审核通过后即可自动发布，审核结果将在2小时内产出'
                    );
                    this.showSubmitSucc = true;
                    this.$emit('submitSuccess');
                    return;
                }
                this.$toast.error((res && res.msg) || '内容提交失败');
            }).catch(() => {
                this.isSubmit = false;
                this.$toast.error('内容提交失败');
            });
        },
        clearForm() {
            this.question = '';
            this.opinion = '';
            this.basis = '';
            this.conclusion = '';
            this.analyse = '';
        },
        fiterLabelHandle(schemeIntroduce) {
            schemeIntroduce = schemeIntroduce.replace(/(\n)/g, '');
            schemeIntroduce = schemeIntroduce.replace(/(\t)/g, '');
            schemeIntroduce = schemeIntroduce.replace(/(\r)/g, '');
            schemeIntroduce = schemeIntroduce.replace(/<\/?[^>]*>/g, '');
            schemeIntroduce = schemeIntroduce.replace(/\s*/g, '');
            schemeIntroduce = schemeIntroduce.replace(/ /ig, ' ');
            return schemeIntroduce;
        }
    }
};
</script>

<style lang='less' scoped>
.ques-edit {
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: rgb(249, 250, 253);

    .header {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        padding: 24px 24px 25px;
        background: #fff;

        .go-back {
            position: relative;
            padding-left: 20px;
            cursor: pointer;

            &::before {
                height: 16px;
                width: 16px;
                position: absolute;
                content: "";
                left: 0;
                top: -1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/left.png") no-repeat center / 100% 100%;
            }
        }

        .line {
            padding: 0 10px;
        }
    }

    .ques-detail {
        padding: 24px;
        background: #fff;
        border-radius: 0 0 8px 8px;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;

        .alert {
            height: 40px;
            margin-top: 24px;
            background: linear-gradient(272.66deg, rgba(126, 105, 255, .1) 1.48%, rgba(61, 117, 255, .1) 97.78%);
            align-items: center;
            color: #1e1f24;

            .close {
                width: 16px;
                height: 16px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/close.png") no-repeat;
                background-size: 100% 100%;
                transform: translateY(3px);
                cursor: pointer;
            }

            /deep/ .veui-alert-state {
                width: 15px;
                height: 15.5px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/icons.png") no-repeat;
                background-size: 100% 100%;

                svg {
                    display: none;
                }
            }
        }

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            text-align: left;
        }

        .ques-input {
            border: none;
            margin-top: 20px;
            margin-bottom: 24px;
            width: 1068px;
            height: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 28px;
            line-height: 28px;
            text-align: left;
            padding: 0;

            /deep/.veui-input-placeholder {
                color: #b7b9c1;
            }

            &.veui-focus {
                box-shadow: none;
            }
        }

        .answer-content {
            display: flex;
            justify-content: space-between;
            height: 685px;
            overflow: hidden;
            padding-top: 24px;

            .answer-exp {
                width: 310px;
                padding: 16px 0;
                background: #fff;
                border-radius: 1px;
                border: 1px solid #d1d1d1;
                position: relative;
                display: flex;
                flex-direction: column;
                overflow: hidden;

                .exp-title {
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1e1f24;
                    line-height: 16px;
                    text-align: left;
                    padding: 0 20px 15px;
                    border-bottom: 1px solid #edeef0;
                }

                .question {
                    margin-top: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1e1f24;
                    line-height: 24px;
                    text-align: justify;
                    padding: 0 20px;
                }

                .answer {
                    margin-top: 13px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #1e1f24;
                    line-height: 20px;
                    text-align: justify;
                    flex: 1;
                    overflow: scroll;
                    padding: 0 20px 34px;
                }

                .btns {
                    height: 50px;
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    left: 0;
                    padding: 0 12px;
                    background: #fff;

                    .veui-button {
                        color: #05f;

                        &.veui-disabled {
                            color: rgba(73, 86, 107, .8);
                        }
                    }

                    .btns-img {
                        width: 16px;
                        height: 16px;
                        display: block;
                        margin: 0 6px;
                    }
                }
            }

            /deep/.ql-editor.ql-blank::before {
                font-family: PingFang SC;
                font-style: normal;
                font-size: 14px;
                color: #1e1f24;
                line-height: 20px;
            }
        }

        .foot-button {
            display: flex;
            justify-content: center;
            text-align: center;
            align-items: center;

            .btn {
                height: 36px;
                line-height: 36px;
                padding: 0 29px;
                border: 1px solid rgba(56, 85, 213, 1);
                border-radius: 4px;
                color: #3855d5;
                background: #fff;
                cursor: pointer;
            }

            .add-btn {
                background: #3855d5;
                color: #fff;
                margin-left: 12px;
            }
        }

        /deep/.veui-select.veui-select-expanded
        .veui-input {
            border: 1px solid #0052cc;
            box-shadow: 0 0 0 2px rgba(0, 102, 255, 20%);
        }

        .veui-input.veui-focus {
            box-shadow: none;
        }

        .ques-editor-box {
            width: 747px;
            height: 100%;
            position: relative;

            .question {
                .my-input {
                    position: relative;

                    .text-num {
                        position: absolute;
                        right: 18px;
                        bottom: 16px;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 14px;
                        color: #848691;
                        z-index: 11;

                        .cur-num {
                            color: #05f;
                        }
                    }
                }

                .question-input {
                    width: 640px;
                    height: 48px;
                    font-size: 16px;
                    color: #1e1f24;
                    border: 1px solid #e9ecf3;
                    border-radius: 6px;
                    background: #fafafa;
                    padding-left: 18px;

                    /deep/.veui-input-placeholder {
                        color: #999;
                    }

                    /deep/.veui-input-count {
                        display: none;
                    }

                    /deep/.veui-input-input {
                        width: 90%;
                    }
                }

                transform: translateY(-15px);

                .focus {
                    border: 1px solid #05f;
                }

                .error {
                    border: 1px solid #fd503e;
                }
            }

            .form-item {
                margin-top: 16px;
                display: flex;
                position: relative;
                padding-bottom: 8px;

                .form-item-label {
                    color: #1e1f24;
                    font-family: PingFang SC;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 16px;
                    text-align: left;
                    position: relative;
                    flex-shrink: 0;
                    margin-right: 33px;

                    &.required::after {
                        content: "";
                        position: absolute;
                        display: inline-block;
                        top: 3px;
                        right: -14px;
                        height: 10px;
                        width: 10px;
                        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/role-set/bixuan.png") no-repeat center center / 100% 100%;
                    }
                }

                .my-textarea {
                    width: 640px;
                    height: 129px;
                    border: 1px solid #e9ecf3;
                    border-radius: 6px;
                    position: relative;
                    padding-bottom: 30px;
                    transform: translateY(-15px);
                    background: #fafafa;

                    &.focus {
                        border: 1px solid #05f;
                    }

                    &.error {
                        border: 1px solid #fd503e;
                    }

                    /deep/.veui-textarea {
                        width: 100%;
                        height: 100%;
                        border: none;
                        color: #1e1f24;
                        font-family: PingFang SC;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 26px;
                        border-radius: 6px;
                        background: #fafafa;

                        .veui-textarea-input {
                            padding: 11px 18px;
                            text-align: justify;
                            background: #fafafa;

                            &::placeholder {
                                color: #999;
                            }
                        }

                        .veui-textarea-count {
                            display: none;
                        }

                        &.veui-focus {
                            border: none;
                            box-shadow: none;
                        }
                    }

                    .text-num {
                        position: absolute;
                        right: 18px;
                        bottom: 12px;
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 14px;
                        color: #848691;
                        z-index: 11;

                        .cur-num {
                            color: #05f;
                        }
                    }

                    .err-tips {
                        font-family: PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #fd503e;
                        line-height: 1;
                        position: absolute;
                        bottom: -20px;
                    }
                }
            }
        }

        /deep/ .ques-editor {
            width: 100%;
            height: 100%;

            .quill-editor {
                height: 100%;
            }

            .ql-container {
                padding: 0 0 30px;
                width: 100%;
                height: calc(100% - 42px);
                border-color: #d3d9e6;
            }

            .ql-toolbar {
                border-color: #d3d9e6;
            }
        }
    }

    .ques-submit {
        margin-top: 24px;
        background: #fff;
        height: 92px;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;

        .btn {
            width: 160px;
            height: 44px;
            background: #05f;
            border-radius: 6px;
            margin: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
            line-height: 22px;
            text-align: center;
        }

        .cancel {
            background: #fff;
            color: #05f;
            margin-left: 0;
            border: 1px solid #05f;
        }
    }

    .submit-succ {
        background: #fff;
        height: 400px;
        border-radius: 0 0 8px 8px;
        text-align: center;
        padding-top: 93px;

        .icon {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            margin: 0 auto;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/upload-succ.png") no-repeat center / 100% 100%;
        }

        .content {
            margin-top: 18px;
            text-align: center;
            height: 18px;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
        }

        .btns {
            margin-top: 30px;

            .veui-button {
                width: 115px;
                height: 40px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #05f;
                color: #05f;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 16px;
            }

            .detail {
                background: #05f;
                border: none;
                color: #fff;
                margin-right: 20px;
            }
        }
    }
}

.ques-edit-old {
    height: 100%;
}
</style>